// routes/FrontendRoutes.js

import React from "react";
import { Route } from "react-router-dom";
import MainLayout from "../layouts/MainLayout";
import CompetitorSuggestions from "../components/Frontend/Competitors/CompetitorSuggestions";
import { CompetitorProvider } from "../context/CompetitorContext";

export const competitorsSuggestionsRoute = (
  <>
    <Route path="/competitor_suggestions" element={<MainLayout />}>
      <Route
        index
        element={
          <CompetitorProvider>
            <CompetitorSuggestions />
          </CompetitorProvider>
        }
      />
    </Route>
  </>
);
